import { useState, type ReactNode } from 'react';
import TimedNotice from '../timedNotice.js';
import { progressPercent, stepLabel, type WizardRouteStep } from './wizardFlow.js';

export default function StepShell(props: {
  step: WizardRouteStep;
  title: string;
  children: ReactNode;
  error?: string | null;
  loading?: boolean;
  status?: string | null;
  showBack?: boolean;
  showSaveWorld?: boolean;
  showReset?: boolean;
  primaryLabel?: string;
  onBack?: () => void;
  onSaveWorld?: () => void;
  onReset?: () => void;
  actions?: ReactNode;
}): JSX.Element {
  const pct = progressPercent(props.step);
  const [saveRun, setSaveRun] = useState(0);

  return (
    <div className="world-wizard">
      <header className="world-wizard-head">
        <div className="world-progress" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
          <div className="world-progress-fill" style={{ width: `${pct}%` }} />
        </div>
        <p className="world-step-label">{stepLabel(props.step)}</p>
        <h1 className="world-title">{props.title}</h1>
      </header>
      <div className="world-wizard-body">{props.children}</div>
      <TimedNotice text={props.status} pulse={saveRun} className="world-status" role="status" />
      <TimedNotice text={props.error} className="world-error" role="alert" />
      {props.loading && <p className="world-loading" aria-live="polite">Working…</p>}
      <footer className="world-wizard-foot">
        <div className="world-foot-secondary">
          {props.showBack && props.onBack && (
            <button type="button" className="btn-ghost" onClick={props.onBack}>Back</button>
          )}
          {props.showSaveWorld && props.onSaveWorld && (
            <button type="button" className="btn-ghost" onClick={() => { setSaveRun((n) => n + 1); props.onSaveWorld?.(); }}>Save World</button>
          )}
          {props.showReset && props.onReset && (
            <button type="button" className="btn-ghost" onClick={props.onReset}>Reset</button>
          )}
        </div>
        <div className="world-foot-primary">{props.actions}</div>
      </footer>
    </div>
  );
}
